import React from "react";

export default function GatewayIdentityCard({ identity, compact = false }) {
  if (!identity) return null;
  const initial = (identity.displayName || identity.username || "C").trim().charAt(0).toUpperCase();
  return (
    <div className={`gatewayIdentity${compact ? " gatewayIdentity--compact" : ""}`}>
      <span className="gatewayAvatar" aria-hidden="true">
        {identity.avatar ? <img src={identity.avatar} alt="" /> : initial}
      </span>
      <div className="gatewayIdentity__copy">
        <strong>{identity.displayName || identity.username}</strong>
        <small>{identity.email || `${identity.username}@clikkmail.com`}</small>
      </div>
      <span className="gatewayIdentity__verified">Verified identity</span>
    </div>
  );
}
